import { render, staticRenderFns } from "./mProduct.vue?vue&type=template&id=8742ce9c&"
import script from "./mProduct.vue?vue&type=script&lang=js&"
export * from "./mProduct.vue?vue&type=script&lang=js&"
import style0 from "./mProduct.vue?vue&type=style&index=0&id=8742ce9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports